// frontend/src/services/sesionEtapaService.js
import api from './api';

const sesionEtapaService = {
  // Obtener información de sesiones por etapa
  getSesionesEtapa: async (params) => {
    try {
      const response = await api.get('/sesiones-etapa', { params });
      return response;
    } catch (error) {
      console.error('Error al obtener sesiones por etapa:', error);
      throw error;
    }
  },

  // Obtener historial de sesiones de una etapa específica
  getHistorialSesionesEtapa: async (pacienteId, etapaId) => {
    try {
      const response = await api.get(`/sesiones-etapa/pacientes/${pacienteId}/etapas/${etapaId}`);
      return response;
    } catch (error) {
      console.error('Error al obtener historial de sesiones:', error);
      throw error;
    }
  },

  // Crear nueva sesión de etapa
  crearSesionEtapa: async (data) => {
    try {
      const response = await api.post('/sesiones-etapa', data);
      return response;
    } catch (error) {
      console.error('Error al crear sesión de etapa:', error);
      throw error;
    }
  },

  // Obtener sesiones pendientes de atención (solo para especialistas)
  getSesionesPendientesAtencion: async () => {
    try {
      const response = await api.get('/sesiones-etapa/pendientes-atencion');
      return response;
    } catch (error) {
      console.error('Error al obtener sesiones pendientes:', error);
      throw error;
    }
  },

  // Marcar sesión como atendida (solo para especialistas)
  marcarSesionAtendida: async (id, observaciones = '') => {
    try {
      const response = await api.put(`/sesiones-etapa/${id}/marcar-atendido`, {
        observaciones
      });
      return response;
    } catch (error) {
      console.error('Error al marcar sesión como atendida:', error);
      throw error;
    }
  },

  // Marcar sesión como no atendida (solo para especialistas)
  marcarSesionNoAtendida: async (id, observaciones = '') => {
    try {
      const response = await api.put(`/sesiones-etapa/${id}/marcar-no-atendido`, {
        observaciones
      });
      return response;
    } catch (error) {
      console.error('Error al marcar sesión como no atendida:', error);
      throw error;
    }
  },

  // Obtener estadísticas de atención
  getEstadisticasAtencion: async (params = {}) => {
    try {
      const response = await api.get('/sesiones-etapa/estadisticas-atencion', { params });
      return response;
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
      throw error;
    }
  },

  // Obtener historial de atenciones de un paciente
  getHistorialAtencionPaciente: async (pacienteId, params = {}) => {
    try {
      const response = await api.get(`/sesiones-etapa/pacientes/${pacienteId}/historial-atencion`, { params });
      return response;
    } catch (error) {
      console.error('Error al obtener historial de atenciones:', error);
      throw error;
    }
  },

  // Obtener sesión por cita ID
   getSesionByCitaId: async (citaId) => {
        try {
        // Buscar todas las sesiones y filtrar por cita_id
        const response = await api.get(`/sesiones-etapa/citas/${citaId}`);
        return response;
        } catch (error) {
        // Si no existe el endpoint específico, intentar con query params
        try {
            const response = await api.get('/sesiones-etapa', {
            params: { cita_id: citaId, limit: 1 }
            });
            return { data: response.data[0] || null };
        } catch (secondError) {
            console.error('Error al obtener sesión por cita:', secondError);
            return { data: null };
        }
        }
    }
};


export default sesionEtapaService;